<template>  
    <div class="SearchPriceDialog">
      <el-dialog  
          :title="searchData.title" 
          width="600px"
          append-to-body
          :visible.sync="visible" 
          @close="$emit('update:show', false)" 
          :show="show">
          <div class="content_box">
            <div class="content_infor_box">
                <baseTable class="basetable_sty" :configData="configData" :tableData="tableData" @rowdblclick="rowdblclick" @clickIcon="clickIcon"/>
            </div>
          </div>
      </el-dialog>
    </div> 

</template>  

<script>

import tool from "@/utils/tool";//本地缓存存取

const priceData = [
    {label:'价格类型',Key:'FullName'},
    {label:'价格',Key:'Price'},
]

export default {
    // 注册组件
    components: {
    },
    data () {  
        return {
            visible: this.show,
            searchText:'',//收索内容
            showLeve:false,//是否显示层级
            tableData:[],//table表格数据
            configData:priceData,//配置项
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        fieldData:String,
        searchData:Object,
    },
    methods:{
        // 请求table表格数据
        InitTable(){
            let params;
            if(this.searchData.type == '单价选择'){
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    PtypeId:this.searchData.data.PtypeId,//商品id
                    BtypeId:this.$attrs.customerVal1.KtypeId,//客户id
                    Unit:this.searchData.data.Unit,//商品单位id
                }
                this.request.post('/index/Goods/get_goods_unit_price', {jparams:JSON.stringify(params)})
                .then(res => {
                    // 接收后端发送回来的数据
                        // console.log(res)
                        this.tableData = Object.values(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                });
            }else{
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    PtypeId:this.searchData.data.PtypeId,//商品id
                    KtypeId:this.$attrs.warehouseVal1.KtypeId,//仓库id
                }
                this.request.post('/index/Goods/get_goods_inv', {jparams:JSON.stringify(params)})
                .then(res => {
                    // 接收后端发送回来的数据
                        // console.log(res)
                        // this.tableData = Object.values(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                });
            }

        },
        // 点击table头部图标返回上一级
        clickIcon(){
            // this.InitTable();
        },
        // 双击table行元素
        rowdblclick(data){
            // console.log(data);
            this.searchData.data.ShowPrice = Number(data.Price).toFixed(2);
            this.searchData.data.Total = (Number(this.searchData.data.Qty) * Number(this.searchData.data.ShowPrice)).toFixed(2);
            this.searchData.data.DiscountPrice = (Number(this.searchData.data.Discount) * Number(this.searchData.data.ShowPrice)).toFixed(2);
            this.searchData.data.DiscountTotal = (Number(this.searchData.data.Discount) * Number(this.searchData.data.Total)).toFixed(2);
            this.searchData.data.TaxTotal = (Number(this.searchData.data.Tax) * Number(this.searchData.data.Total)).toFixed(2);
            this.searchData.data.TaxPrice = ((Number(this.searchData.data.Tax)+1) * Number(this.searchData.data.ShowPrice)).toFixed(2);//产品含税单价
            this.searchData.data.WithTaxTotal = ((Number(this.searchData.data.Tax)+1) * Number(this.searchData.data.Total)).toFixed(2);//产品含税金额

            this.$emit('dbclickRow', [this.searchData.data])
            this.$emit('update:show', false)
        },
    },
    watch: {  
        show (){  
            this.visible = this.show;
        },
        'searchData.type':{
            handler(newValue, oldValue) {
                this.InitTable();
            },
            deep: true
        }
    },
    created(){
        this.InitTable();
    },
    // 创建生命周期钩子函数
    beforeUpdate() {

    }
};  
</script>

<style lang="less">
.SearchPriceDialog{
  .el-dialog__header{
      background: rebeccapurple;
      // background: #4990d7;
      padding: 10px 10px 0;
      .el-dialog__title{
        color: #fff;
        font-size: 14px;
      }
      .el-dialog__headerbtn{
        top: 10px;
        right: 10px;
        .el-dialog__headerbtn .el-dialog__close{
          color: #fff;
        }
      }
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
  .content_box{
    .content_top{
      width: 100%;
      height: 40px;
      display: -webkit-box !important;
      display: box !important;
      position:relative;
      -webkit-box-align:center;
      box-align:center;
      .search_input{
        display: block;
        width: 200px;
      }
    }
    .content_infor_box{
        width: 100%;
        height: 300px;
    }
  }
}
    .basetable_sty{
        width: 100%;
        height: 300px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Dialog/SearchPriceDialog/SearchPriceDialog.vue